import { faCopy, faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress } from '@material-ui/core';
import { FormikProps } from 'formik';
import * as React from 'react';
import { ComboRequestGq } from '../../../graphql/projects/models/ComboRequestGq';
import { KeywordCalculation } from '../Tables/KeywordTable/ToolbarButtons/AddKeywords/AddComboKeywords/EditComboRequestView/logic/useCalculateKeywords';
import { useExecute } from '../Tables/KeywordTable/ToolbarButtons/AddKeywords/AddComboKeywords/EditComboRequestView/logic/useExecute';
import { ComboFormState } from '../Tables/KeywordTable/ToolbarButtons/AddKeywords/AddComboKeywords/EditComboRequestView/models/ComboFormState';
import VoxelButton from '../../voxel/Buttons/VoxelButton';
import ComboExecuteDialog from '../Dialogs/ComboExecuteDialog';

export interface ComboButtonSectionProps {
  formState: FormikProps<ComboFormState>;
  wordCount: KeywordCalculation;
  comboRequest: ComboRequestGq;
  copying: boolean;
  copyRequest: () => Promise<void>;
  handleClose: () => void;
  executeState: ReturnType<typeof useExecute>;
}

const ComboButtonSection: React.FC<ComboButtonSectionProps> = ({
  formState,
  copying,
  wordCount,
  copyRequest,
  comboRequest,
  executeState,
  handleClose,
}) => {
  const mutating = copying || executeState.loading;

  return (
    <div>
      <ComboExecuteDialog executeBag={executeState} />
      <div className="flex flex-row gap-3">
        <VoxelButton title="Cancel" shape="square" color="white" onClick={handleClose} />
        <VoxelButton
          title="Create search"
          shape="square"
          color="primary"
          onClick={executeState.handleTryExecuting}
          disabled={
            wordCount.requestPermission ||
            !!comboRequest.processingStartTime ||
            wordCount.keywordCount === 0 ||
            !formState.isValid ||
            mutating
          }
          startIcon={<FontAwesomeIcon icon={faSearch} />}
        >
          Execute
        </VoxelButton>
        {!!comboRequest.processingStartTime && (
          <VoxelButton
            title="Copy"
            shape="square"
            color="primary"
            endIcon={copying ? <CircularProgress size={18} /> : <FontAwesomeIcon icon={faCopy} />}
            disabled={mutating}
            onClick={copyRequest}
          />
        )}
      </div>
    </div>
  );
};

export default ComboButtonSection;
